import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_login_form = _resolveComponent("login-form")!
  const _component_network_error = _resolveComponent("network-error")!

  return (_openBlock(), _createElementBlock("div", {
    id: "login-container",
    class: _normalizeClass({ green: _ctx.isGreenOrRed('green'), red: _ctx.isGreenOrRed('red') })
  }, [
    (!_ctx.connectionLost)
      ? (_openBlock(), _createBlock(_component_login_form, {
          key: 0,
          value: _ctx.loginFailed,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loginFailed) = $event)),
          onSubmitLogin: _cache[1] || (_cache[1] = ($event: any) => (_ctx.login($event)))
        }, null, 8, ["value"]))
      : (_openBlock(), _createBlock(_component_network_error, {
          key: 1,
          "login-retry-pending": _ctx.loading,
          onRetryLogin: _cache[2] || (_cache[2] = () => _ctx.login({ username: _ctx.usernameCache, password: _ctx.passwordCache }))
        }, null, 8, ["login-retry-pending"]))
  ], 2))
}